import { render, staticRenderFns } from "./emergencyHandle.vue?vue&type=template&id=204366dd&scoped=true&"
import script from "./emergencyHandle.vue?vue&type=script&lang=js&"
export * from "./emergencyHandle.vue?vue&type=script&lang=js&"
import style0 from "./emergencyHandle.vue?vue&type=style&index=0&id=204366dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204366dd",
  null
  
)

export default component.exports